const Home = () => import('../../../components/layout/Home.vue');
export default [
    {
        path: '/chat',
        component: Home,
        children: [
            {
                path: '',
                component: () => import('./chat.vue'),
                meta: { title: '聊天管理' }
            }
        ]
    },
    {
        path: '/chatHistory',
        component: Home,
        children: [
            {
                path: '',
                component: () => import('./chatHistory.vue'),
                meta: { title: '聊天记录' }
            }
        ]
    },
    {
        path: '/prescriptions',
        component: Home,
        children: [
            {
                path: '',
                component: () => import('./Prescription.vue'),
                meta: { title: '处方管理' }
            }
        ]
    },
    {
        path: '/medicalRecord',
        component: Home,
        children: [
            {
                path: '',
                component: () => import('./medicalRecord.vue'),
                meta: { title: '病历记录' }
            }
        ]
    },
    {
        path: '/order',
        component: Home,
        children: [
            {
                path: '',
                component: () => import('./order.vue'),
                meta: { title: '预约管理' }
            }
        ]
    },
    {
        path: '/orderDetails',
        component: Home,
        children: [
            {
                path: '',
                component: () => import('./orderDetails.vue'),
                meta: { title: '预约详情' }
            }
        ]
    },
]